class EventsFilters {
    static init() {
        this.itemsPerPage = 4;
        this.btnMore = document.querySelector('.c-events-readMore');
        this.events = document.querySelectorAll('.c-events__list-item');
        this.categoriesList = document.querySelector('.c-events__categories');
        if (document.querySelectorAll('.js-category-btn').length > 0 && document.querySelectorAll('.c-events__list-item').length > 0) {
            var categoriesBtns = document.querySelectorAll('.js-category-btn');
            var activeCategory = document.querySelector(".c-events__categories-item.active").getAttribute('data-category');
            this.displayEvents(activeCategory);
            categoriesBtns.forEach(btn => {
                btn.addEventListener('click', (e) => {
                    categoriesBtns.forEach(btn => {
                        btn.parentNode.classList.remove('active')
                    })
                    e.target.parentNode.classList.add('active')
                    activeCategory = e.target.parentNode.getAttribute('data-category')
                    this.displayEvents(activeCategory)
                    this.categoriesList.classList.remove('open')
                })
            })
            this.btnMore.addEventListener('click', () => {
                this.events.forEach(event => {
                    if (event.getAttribute('data-category') === activeCategory && !event.classList.contains('displayed')) {
                        event.classList.add('displayed');
                        this.btnMore.style.display = "none";
                    }
                })
            })
            if (window.innerWidth < 991) {
                this.dropDownMenuMobile()
            }
        }
    }
    static displayEvents(activeCategory) {
        var i = 0
        this.events.forEach(event => {
            if (event.getAttribute('data-category') === activeCategory) {
                i++
                if (i <= this.itemsPerPage) {
                    this.btnMore.style.display = "none"
                    event.classList.add("displayed");
                } else {
                    this.btnMore.style.display = "block"
                }
            } else {
                event.classList.remove("displayed");
            }
        })
    }
    static dropDownMenuMobile() {
        this.categoriesList.addEventListener('click', (e) => {
            e.target.classList.toggle('open');
        })
    }
}

export default EventsFilters;


// WEBPACK FOOTER //
// ./src/scripts/components/eventsFilters.js